type UiConfig = Parameters<typeof defineAppConfig>[0]['ui']

export const uiConfig: UiConfig = {
  colors: {
    primary: 'sky',
    neutral: 'neutral',
    tertiary: 'tertiary',
  },
  button: {
    variants: {
      size: {
        xl: {
          // ≥44px hit target for chrome / primary CTAs
          base: 'px-6 py-2.5 min-h-11',
        },
      },
    },
    /**
     * Solid primary: sky-500 + white fails WCAG AA (~2.7:1).
     * Use sky-700 fill so chrome Main and solid CTAs stay ≥4.5:1.
     */
    compoundVariants: [
      {
        color: 'primary',
        variant: 'solid',
        class:
          'text-white bg-sky-700 hover:bg-sky-800 active:bg-sky-800 disabled:bg-sky-700 aria-disabled:bg-sky-700 outline-sky-700/25 focus-visible:outline-3',
      },
    ],
    defaultVariants: {
      size: 'xl',
    },
  },
  formField: {
    slots: {
      label: 'text-xs font-normal text-muted',
      error: 'mt-1 text-xs',
      help: 'mt-1 text-xs text-dimmed',
    },
  },
  input: {
    defaultVariants: {
      size: 'xl',
    },
  },

  inputTags: {
    defaultVariants: {
      size: 'xl',
    },
  },

  textarea: {
    defaultVariants: {
      size: 'xl',
    },
  },
  inputNumber: {
    defaultVariants: {
      size: 'xl',
    },
  },
  inputDate: {
    defaultVariants: {
      size: 'xl',
    },
  },
  select: {
    defaultVariants: {
      size: 'xl',
    },
  },
  selectMenu: {
    defaultVariants: {
      size: 'xl',
    },
  },
  table: {
    slots: {
      th: 'px-2 py-1 text-xs font-normal text-muted',
      td: 'px-2 py-4 text-highlighted',
    },
  },
  modal: {
    slots: {
      content: 'divide-none',
    },
  },
  slideover: {
    slots: {
      overlay: 'bg-black/40',
    },
  },
  header: {
    slots: {
      root: 'bg-default border-b border-default h-(--ui-header-height) sticky top-0 z-50',
    },
  },
}
